export default __webpack_public_path__ + "static/media/con_MOVG10.8425eca5.jpg";